import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

let token;
export function setToken(t) { token = t; }

const auth = () => token ? { Authorization: `Bearer ${token}` } : {};
const headers = () => ({ 'Content-Type': 'application/json', ...auth() });

// ===== Events =====

export const fetchEvents = async () => {
    const res = await axios.get(`${API_BASE_URL}/event`, { headers: auth() });
    return res.data;
};

export const fetchEvent = async (eventId) => {
    const res = await axios.get(`${API_BASE_URL}/event/${eventId}`, { headers: auth() });
    return res.data;
};

export const createEvent = async (data) => {
    const res = await axios.post(`${API_BASE_URL}/event`, data, { headers: headers() });
    return res.data;
};

export const updateEvent = async (eventId, data) => {
    const res = await axios.put(`${API_BASE_URL}/event/${eventId}`, data, { headers: headers() });
    return res.data;
};

export const deleteEvent = async (eventId) => {
    await axios.delete(`${API_BASE_URL}/event/${eventId}`, { headers: auth() });
};

// ===== Attendance =====

export const fetchAttendance = async (eventId) => {
    const res = await axios.get(`${API_BASE_URL}/event/${eventId}/attendance`, { headers: auth() });
    return res.data;
};

export const fetchAttendanceRecord = async (eventId, playerId) => {
    const res = await axios.get(`${API_BASE_URL}/event/${eventId}/attendance/${playerId}`, { headers: auth() });
    return res.data;
};

export const upsertAttendance = async (eventId, playerId, data) => {
    const res = await axios.put(`${API_BASE_URL}/event/${eventId}/attendance/${playerId}`, data, { headers: headers() });
    return res.data;
};

export const deleteAttendance = async (eventId, playerId) => {
    await axios.delete(`${API_BASE_URL}/event/${eventId}/attendance/${playerId}`, { headers: auth() });
};

// ===== Players & Characters (for dropdowns) =====

export const fetchAllPlayers = async () => {
    const res = await axios.get(`${API_BASE_URL}/player`, { headers: auth() });
    return res.data;
};

export const fetchCharactersForPlayer = async (playerId) => {
    const res = await axios.get(`${API_BASE_URL}/character?playerId=${playerId}`, { headers: auth() });
    return res.data;
};
